import request from '../../utils/request'
const signed = (fromAction,data) => {
    return request({
        url: process.env.VUE_APP_API + `appointment/signed/${fromAction}`,
        method: 'POST',
        data
    })
}
const checkSigned = () => {
    return request({
        url: process.env.VUE_APP_API + 'appointment/check/signed',
        method: 'GET',
    })
}
const checkCount = () => {
    return request({
        url: process.env.VUE_APP_API + 'appointment/count',
        method: 'GET',
    })
}
const preIdentity = (data) => {
    return request({
        url: process.env.VUE_APP_API + 'sub/presented-policy-identity',
        method: 'POST',
        data,
    })
}

const receive = (data,tmpl) => {
    return request({
        url: process.env.VUE_APP_TRADER + `order/receive/${tmpl}`,
        method: 'POST',
        data,
    })
}
const checkIdentity = (data) => {
    return request({
        url: process.env.VUE_APP_API + 'sub/check-policy-identity',
        method: 'GET',
    })
}
// 卡券活动 超级福袋购买
const superLuckybag = (data) => {
  return request({
      url: process.env.VUE_APP_API + `openapi/activity/super-luckybag`,
      method: 'post',
      data
  })
}
export {
    signed,
    checkSigned,
    checkCount,
    preIdentity,
    checkIdentity,
    receive,
    superLuckybag
}